import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LoggingService {
  info(message: string, ...data: any[]): void {
    if (environment.enableLogging) console.log(`[INFO] ${message}`, ...data);
  }

  warn(message: string, ...data: any[]): void {
    if (environment.enableLogging) console.warn(`[WARN] ${message}`, ...data);
  }

  error(message: string, ...data: any[]): void {
    console.error(`[ERROR] ${message}`, ...data);
  }

  debug(message: string, ...data: any[]): void {
    if (environment.enableLogging) console.debug(`[DEBUG] ${message}`, ...data);
  }
}
